// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Injectable } from '@angular/core';

//Services
import { WebServices } from './webServices';
import { CPDFormatters } from '../../shared/services/cpd-formatters';

@Injectable()
export class FeatureFlagService {
    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    _featureFlags = [];

    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(webServices: WebServices,
        cpdFormatters: CPDFormatters) {
        this.constructor.mapParams(this, arguments);
    }

    // PUBLIC FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //============================================
    // getFeatureFlag
    //============================================
    async getFeatureFlag(keyName) {
        if (this._featureFlags.length == 0) {
            await this._setFeatureFlags();
        }
        let flagObject = this._featureFlags.find(flag => flag.KeyName == keyName);
        if (flagObject) {
            return flagObject.KeyValue.toLowerCase() == "true";
        }
        return false;
    }

    //============================================
    // getFeatureFlags
    //============================================
    async getFeatureFlags() {
        if (this._featureFlags.length == 0) {
            await this._setFeatureFlags();
        }
        return this._featureFlags;
    }

    // PRIVATE FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //============================================
    // _setFeatureFlags
    //============================================
    async _setFeatureFlags() {
        let response = await this.webServices.Get({
            apiPath: "/featureflag/getFeatureFlags",
        })
            .catch(err => {
                console.log(`[FeatureFlagService]: Error getting feature flags.`, this.cpdFormatters.formatError(err));
                alert("Unexpected FFS Error (details in console)");
                return;
            });
        if (!response || !response.data || !response.data.DTO) {
            throw ("Cannot find feature flag data.");
        }
        console.log(`[FeatureFlagService:/featureflag/getFeatureFlags] - res: `, response);
        this._featureFlags = response.data.DTO;
    }
}